import React from 'react'

import _get from 'lodash/get'
import _isEmpty from 'lodash/isEmpty'

// style
import './global-nav-header.less'

const GlobalNavHeader = ({ isLoggedIn, navigation, head }) => {
  if (isLoggedIn) {
    return <></>
  }

  const header = _get(navigation, 'globalNav.header', {})
  if (_isEmpty(header)) {
    return <></>
  }

  if (head) {
    return (
      <>
        <div
          data-testid="hc-globalNav-header-head"
          dangerouslySetInnerHTML={{ __html: header.headHtml || '' }}
        />
      </>
    )
  }

  return (
    <>
      <div
        className="globalnav-header"
        data-testid="hc-globalNav-header-body"
        dangerouslySetInnerHTML={{ __html: header.bodyHtml || '' }}
      />
    </>
  )
}

export default GlobalNavHeader
